(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dope-language-switcher')) {
    customElements.define('dope-language-switcher', class extends HTMLElement {
      connectedCallback() {
        if (this.languageAbort) this.languageAbort.abort();
        this.languageAbort = new AbortController();
        const options = { signal: this.languageAbort.signal };
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-language-open]');
        const form = this.querySelector('form');
        if (!dialog || !opener || !form) return;
        const visitKey = 'dope.language.visit.v1';
        const rememberVisit = () => { try { sessionStorage.setItem(visitKey, '1'); } catch {} };
        const open = () => { if (!dialog.open) { dialog.showModal(); opener.setAttribute('aria-expanded', 'true'); } };
        opener.addEventListener('click', open, options);
        this.querySelector('[data-language-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('close', () => { rememberVisit(); opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }, options);
        dialog.addEventListener('cancel', rememberVisit, options);
        dialog.addEventListener('click', (event) => { if (event.target !== dialog) return; const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); }, options);
        form.addEventListener('submit', (event) => {
          rememberVisit();
          if (event.submitter?.value === dialog.dataset.currentLanguage) { event.preventDefault(); dialog.close(); return; }
          form.querySelector('[name="return_to"]').value = location.pathname + location.search + location.hash;
        }, options);
        let firstVisit = false;
        try { firstVisit = !sessionStorage.getItem(visitKey); } catch { try { firstVisit = !document.referrer || new URL(document.referrer).origin !== location.origin; } catch { firstVisit = true; } }
        if (firstVisit && !dialog.hasAttribute('data-design-mode') && Number(dialog.dataset.languageCount) > 1) { rememberVisit(); open(); }
      }
      disconnectedCallback() { this.languageAbort?.abort(); const dialog = this.querySelector('dialog'); if (dialog?.open) dialog.close(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
